import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import * as XLSX from "xlsx";
import db from "../Firebase";

// ── Static subscription list ──────────────────────────────────────────────────
const RAW_DATA = [

    { plan: "Glow", number: "9913654517", date_of_subscription: "2/3/2025" },
    { plan: "Glow", number: "9899473104", date_of_subscription: "2/7/2025" },
    { plan: "Glow", number: "7974480298", date_of_subscription: "2/7/2025" },
    { plan: "Glow", number: "9810255895", date_of_subscription: "2/18/2025" },
    { plan: "Glow", number: "7520255478", date_of_subscription: "5/1/2025" },
    { plan: "Glow Plus", number: "7827557974", date_of_subscription: "5/1/2025" },
    { plan: "Glow", number: "7827557974", date_of_subscription: "5/1/2025" },
    { plan: "Glow Plus", number: "7827557974", date_of_subscription: "5/1/2025" },
    { plan: "Glow Max", number: "9596287100", date_of_subscription: "5/3/2025" },
    { plan: "Glow", number: "9076378835", date_of_subscription: "5/4/2025" },
    { plan: "Glow Max", number: "8850260998", date_of_subscription: "5/6/2025" },
    { plan: "Glow", number: "9338167699", date_of_subscription: "5/7/2025" },
    { plan: "Glow", number: "9056482298", date_of_subscription: "5/7/2025" },
    { plan: "Glow", number: "8160813801", date_of_subscription: "5/10/2025" },
    { plan: "Glow Plus", number: "6239980031", date_of_subscription: "5/11/2025" },
    { plan: "Glow Plus", number: "9821376937", date_of_subscription: "5/13/2025" },
    { plan: "Glow Plus", number: "8889960890", date_of_subscription: "5/13/2025" },
    { plan: "Glow", number: "9685452154", date_of_subscription: "5/15/2025" },
    { plan: "Glow", number: "9113323038", date_of_subscription: "5/15/2025" },
    { plan: "Glow", number: "8279720653", date_of_subscription: "5/16/2025" },
    { plan: "Glow", number: "7347443577", date_of_subscription: "5/17/2025" },
    { plan: "Glow", number: "8446790910", date_of_subscription: "5/17/2025" },
    { plan: "Glow", number: "7500820925", date_of_subscription: "5/17/2025" },
    { plan: "Glow", number: "9604342600", date_of_subscription: "5/18/2025" },
    { plan: "Glow Plus", number: "9922426071", date_of_subscription: "5/23/2025" },
    { plan: "Glow", number: "7906724560", date_of_subscription: "5/26/2025" },
    { plan: "Glow", number: "9389680477", date_of_subscription: "5/26/2025" },
    { plan: "Glow Max", number: "9993380908", date_of_subscription: "5/29/2025" },
    { plan: "Glow", number: "8889435024", date_of_subscription: "6/4/2025" },
    { plan: "Glow Plus", number: "9917697700", date_of_subscription: "6/4/2025" },
    { plan: "Glow", number: "9001870112", date_of_subscription: "6/6/2025" },
    { plan: "Glow Max", number: "9043209353", date_of_subscription: "6/9/2025" },
    { plan: "Glow", number: "6306793846", date_of_subscription: "6/11/2025" },
    { plan: "Glow", number: "6351826379", date_of_subscription: "6/13/2025" },
    { plan: "Glow", number: "7906724560", date_of_subscription: "6/15/2025" },
    { plan: "Glow", number: "7599126069", date_of_subscription: "6/24/2025" },
    { plan: "Glow", number: "7520255478", date_of_subscription: "6/29/2025" },
    { plan: "Glow", number: "7903926281", date_of_subscription: "6/30/2025" },
    { plan: "Glow Plus", number: "7903926281", date_of_subscription: "6/30/2025" },
    { plan: "Glow Max", number: "9005116052", date_of_subscription: "6/30/2025" },
    { plan: "Glow", number: "8288867830", date_of_subscription: "7/3/2025" },
    { plan: "Glow Plus", number: "7658031153", date_of_subscription: "7/4/2025" },
    { plan: "Glow", number: "8288867830", date_of_subscription: "7/4/2025" },
    { plan: "Glow", number: "9911972830", date_of_subscription: "7/4/2025" },
    { plan: "Glow", number: "9354480017", date_of_subscription: "7/5/2025" },
    { plan: "Glow", number: "9510166391", date_of_subscription: "7/14/2025" },
    { plan: "Glow", number: "9503817828", date_of_subscription: "7/15/2025" },
    { plan: "Glow", number: "6200070178", date_of_subscription: "7/15/2025" },
    { plan: "Glow", number: "9864661089", date_of_subscription: "7/16/2025" },
    { plan: "Glow", number: "8073582785", date_of_subscription: "7/18/2025" },
    { plan: "Glow Plus", number: "9338167699", date_of_subscription: "7/22/2025" },
    { plan: "Glow Max", number: "9783934808", date_of_subscription: "7/23/2025" },
    { plan: "Glow", number: "9426562129", date_of_subscription: "7/23/2025" },
    { plan: "Glow", number: "9101888974", date_of_subscription: "7/27/2025" },
    { plan: "Glow", number: "7906724560", date_of_subscription: "7/29/2025" },
    { plan: "Glow", number: "6351826379", date_of_subscription: "7/31/2025" },
    { plan: "Glow", number: "8591580590", date_of_subscription: "7/31/2025" },
    { plan: "Glow", number: "7877523530", date_of_subscription: "8/1/2025" },
    { plan: "Glow", number: "9680525334", date_of_subscription: "8/1/2025" },
    { plan: "Glow", number: "7397425019", date_of_subscription: "8/1/2025" },
    { plan: "Glow", number: "8421461395", date_of_subscription: "8/1/2025" },
    { plan: "Glow", number: "6350508671", date_of_subscription: "8/2/2025" },
    { plan: "Glow", number: "8200924068", date_of_subscription: "8/3/2025" },
    { plan: "Glow Max", number: "9922389574", date_of_subscription: "8/3/2025" },
    { plan: "Glow", number: "9619245440", date_of_subscription: "8/4/2025" },
    { plan: "Glow", number: "8338045409", date_of_subscription: "8/4/2025" },
    { plan: "Glow", number: "7225068711", date_of_subscription: "8/5/2025" },
    { plan: "Glow", number: "9354480017", date_of_subscription: "8/7/2025" },
    { plan: "Glow", number: "7507352912", date_of_subscription: "8/8/2025" },
    { plan: "Glow", number: "9960983025", date_of_subscription: "8/11/2025" },
    { plan: "Glow", number: "6351826379", date_of_subscription: "8/12/2025" },
    { plan: "Glow", number: "9724760645", date_of_subscription: "8/13/2025" },
    { plan: "Glow", number: "7520255478", date_of_subscription: "8/20/2025" },
    { plan: "Glow", number: "9329999090", date_of_subscription: "8/22/2025" },
    { plan: "Glow Plus", number: "6301765515", date_of_subscription: "8/23/2025" },
    { plan: "Glow", number: "8224803704", date_of_subscription: "8/23/2025" },
    { plan: "Glow", number: "9101888974", date_of_subscription: "8/29/2025" },
    { plan: "Glow", number: "9974591892", date_of_subscription: "9/1/2025" },
    { plan: "Glow", number: "7500820925", date_of_subscription: "9/2/2025" },
    { plan: "Glow", number: "7892416136", date_of_subscription: "9/2/2025" },
    { plan: "Glow", number: "8144334079", date_of_subscription: "9/5/2025" },
    { plan: "Glow", number: "9574413797", date_of_subscription: "9/5/2025" },
    { plan: "Glow", number: "8288867830", date_of_subscription: "9/5/2025" },
    { plan: "Glow", number: "7383484957", date_of_subscription: "9/9/2025" },
    { plan: "Glow", number: "9354405527", date_of_subscription: "9/10/2025" },
    { plan: "Glow", number: "7995183316", date_of_subscription: "9/11/2025" },
    { plan: "Glow", number: "9211623039", date_of_subscription: "9/12/2025" },
    { plan: "Glow", number: "6351826379", date_of_subscription: "9/12/2025" },
    { plan: "Glow", number: "7774932391", date_of_subscription: "9/12/2025" },
    { plan: "Glow", number: "8224803704", date_of_subscription: "9/15/2025" },
    { plan: "Glow", number: "9769087856", date_of_subscription: "9/15/2025" },
    { plan: "Glow", number: "8483020879", date_of_subscription: "9/20/2025" },
    { plan: "Glow", number: "9917697700", date_of_subscription: "9/23/2025" },
    { plan: "Glow", number: "6302214615", date_of_subscription: "9/25/2025" },
    { plan: "Glow", number: "7784975462", date_of_subscription: "9/26/2025" },
    { plan: "Glow", number: "7826000951", date_of_subscription: "9/26/2025" },
    { plan: "Glow", number: "9343863538", date_of_subscription: "9/27/2025" },
    { plan: "Glow", number: "8546044415", date_of_subscription: "9/29/2025" },
    { plan: "Glow", number: "8469580946", date_of_subscription: "9/29/2025" },
    { plan: "Glow", number: "9324183755", date_of_subscription: "9/30/2025" },
    { plan: "Glow Plus", number: "9922426071", date_of_subscription: "9/30/2025" },
    { plan: "Glow", number: "7599126069", date_of_subscription: "10/6/2025" },
    { plan: "Glow", number: "9625712878", date_of_subscription: "10/7/2025" },
    { plan: "Glow", number: "8056963862", date_of_subscription: "10/8/2025" },
    { plan: "Glow", number: "6351826379", date_of_subscription: "10/8/2025" },
    { plan: "Glow", number: "7841823327", date_of_subscription: "10/9/2025" },
    { plan: "Glow", number: "9888248866", date_of_subscription: "11/3/2025" },
    { plan: "Glow", number: "8016063410", date_of_subscription: "11/3/2025" },
    { plan: "Glow", number: "8923961985", date_of_subscription: "11/5/2025" },
    { plan: "Glow", number: "9113323038", date_of_subscription: "11/5/2025" },
    { plan: "Glow", number: "6207847422", date_of_subscription: "11/7/2025" },
    { plan: "Glow Plus", number: "7599126069", date_of_subscription: "11/11/2025" },
    { plan: "Glow", number: "7799722131", date_of_subscription: "11/12/2025" },
    { plan: "Glow", number: "6351826379", date_of_subscription: "11/13/2025" },
    { plan: "Glow", number: "8788147169", date_of_subscription: "11/17/2025" },
    { plan: "Glow", number: "9028133963", date_of_subscription: "11/17/2025" },
    { plan: "Glow", number: "7502627786", date_of_subscription: "11/20/2025" },
    { plan: "Glow", number: "8289934721", date_of_subscription: "11/21/2025" },
    { plan: "Glow", number: "6376089576", date_of_subscription: "11/27/2025" },
    { plan: "Glow Plus", number: "9836223862", date_of_subscription: "11/30/2025" },
    { plan: "Glow", number: "8570960096", date_of_subscription: "12/4/2025" },
    { plan: "Glow", number: "9354480017", date_of_subscription: "12/4/2025" },
    { plan: "Glow Max", number: "9917697700", date_of_subscription: "12/8/2025" },
    { plan: "Glow Plus", number: "9510166391", date_of_subscription: "12/12/2025" },
    { plan: "Glow", number: "7984858364", date_of_subscription: "12/14/2025" },
    { plan: "Glow", number: "9510166391", date_of_subscription: "12/14/2025" },
    { plan: "Glow", number: "9949093140", date_of_subscription: "12/14/2025" },
    { plan: "Glow", number: "8546044415", date_of_subscription: "12/16/2025" },
    { plan: "Glow Plus", number: "9773504331", date_of_subscription: "12/18/2025" },
    { plan: "Glow Max", number: "7397965476", date_of_subscription: "12/25/2025" },
    { plan: "Glow", number: "9708201005", date_of_subscription: "12/26/2025" },
    { plan: "Glow", number: "9579361967", date_of_subscription: "1/2/2026" },
    { plan: "Glow", number: "6358070335", date_of_subscription: "1/4/2026" },
    { plan: "Glow", number: "7559114620", date_of_subscription: "1/7/2026" },
    { plan: "Glow Plus", number: "7225068711", date_of_subscription: "1/10/2026" },
    { plan: "Glow", number: "7004871314", date_of_subscription: "1/11/2026" },
    { plan: "Glow", number: "9113323038", date_of_subscription: "1/14/2026" },
    { plan: "Glow", number: "9833260183", date_of_subscription: "1/17/2026" },
    { plan: "Glow", number: "6302214615", date_of_subscription: "1/19/2026" },
    { plan: "Glow", number: "9001870112", date_of_subscription: "1/26/2026" },
    { plan: "Glow", number: "8923961985", date_of_subscription: "1/27/2026" },
    { plan: "Glow Max", number: "9899712426", date_of_subscription: "2/9/2026" },
    { plan: "Glow", number: "8333002520", date_of_subscription: "2/11/2026" },
    { plan: "Glow", number: "6239051123", date_of_subscription: "2/16/2026" },
    { plan: "Glow Plus", number: "9833260183", date_of_subscription: "2/16/2026" },
    { plan: "Glow Plus", number: "6351826379", date_of_subscription: "2/17/2026" },
    { plan: "Glow", number: "7388876838", date_of_subscription: "2/18/2026" },
    { plan: "Glow", number: "9014711778", date_of_subscription: "2/19/2026" },
    { plan: "Glow", number: "9113323038", date_of_subscription: "2/19/2026" },
    { plan: "Glow Plus", number: "7225068711", date_of_subscription: "2/20/2026" },
    { plan: "Glow Plus", number: "7887871119", date_of_subscription: "2/24/2026" },
    { plan: "Glow", number: "9205100898", date_of_subscription: "2/25/2026" },
    { plan: "Glow", number: "9574413797", date_of_subscription: "2/25/2026" },
    { plan: "Glow", number: "8923961985", date_of_subscription: "2/26/2026" },
    { plan: "Glow", number: "7055447788", date_of_subscription: "2/26/2026" },
    { plan: "Glow Max", number: "7218667712", date_of_subscription: "3/2/2026" },
    { plan: "Glow", number: "7218667712", date_of_subscription: "3/3/2026" },
    { plan: "Glow", number: "8980535658", date_of_subscription: "3/6/2026" },
    { plan: "Glow", number: "8085671766", date_of_subscription: "3/12/2026" },
    { plan: "Glow", number: "7274898934", date_of_subscription: "3/15/2026" },
    { plan: "Glow", number: "6263173559", date_of_subscription: "3/16/2026" },
    { plan: "Glow", number: "8546044415", date_of_subscription: "3/18/2026" },
    { plan: "Glow", number: "9113323038", date_of_subscription: "3/22/2026" },
    { plan: "Glow", number: "9014711778", date_of_subscription: "3/27/2026" },
    { plan: "Glow", number: "9850700809", date_of_subscription: "3/31/2026" },
    { plan: "Glow Plus", number: "9773504331", date_of_subscription: "4/2/2026" },
    { plan: "Glow", number: "7218667712", date_of_subscription: "4/2/2026" },
    { plan: "Glow", number: "7218667712", date_of_subscription: "4/2/2026" },
    { plan: "Glow Max", number: "7218667712", date_of_subscription: "4/3/2026" },
    { plan: "Glow Plus", number: "7218667712", date_of_subscription: "4/3/2026" },
    { plan: "Glow", number: "9579361967", date_of_subscription: "4/4/2026" },
    { plan: "Glow", number: "9916385551", date_of_subscription: "4/11/2026" },
    { plan: "Glow Plus", number: "9510166391", date_of_subscription: "4/14/2026" },
    { plan: "Glow", number: "9236309046", date_of_subscription: "4/14/2026" },
    { plan: "Glow", number: "9098864794", date_of_subscription: "4/20/2026" },
    { plan: "Glow Plus", number: "7853974279", date_of_subscription: "4/21/2026" },
    { plan: "Glow", number: "9881531404", date_of_subscription: "4/22/2026" },
    { plan: "Glow", number: "9113323038", date_of_subscription: "4/23/2026" },
    { plan: "Glow", number: "8687109337", date_of_subscription: "4/24/2026" },
    { plan: "Glow", number: "9716584386", date_of_subscription: "4/27/2026" },
    { plan: "Glow", number: "9912563504", date_of_subscription: "4/30/2026" },
    { plan: "Glow", number: "9912563504", date_of_subscription: "4/30/2026" },
    { plan: "Glow", number: "9953068114", date_of_subscription: "5/1/2026" },
    { plan: "Glow", number: "9825008002", date_of_subscription: "5/6/2026" },
    { plan: "Glow", number: "9888248866", date_of_subscription: "5/6/2026" },
    { plan: "Glow", number: "7989216775", date_of_subscription: "5/10/2026" },
    { plan: "Glow", number: "7017902365", date_of_subscription: "5/13/2026" },
    { plan: "Glow", number: "8297891138", date_of_subscription: "5/16/2026" },
    { plan: "Glow", number: "6351826379", date_of_subscription: "5/18/2026" },



];

const UNIQUE_NUMBERS = [...new Set(RAW_DATA.map((d) => d.number))];

// Count total occurrences per number (first = original sub, rest = renewals)
const countMap = RAW_DATA.reduce((acc, d) => {
    acc[d.number] = (acc[d.number] || 0) + 1;
    return acc;
}, {});

// First subscription date per number
const firstSubMap = RAW_DATA.reduce((acc, d) => {
    if (!acc[d.number]) acc[d.number] = d.date_of_subscription;
    return acc;
}, {});

// All subscription entries per number (for renewed popup)
const allSubDatesMap = RAW_DATA.reduce((acc, d) => {
    if (!acc[d.number]) acc[d.number] = [];
    acc[d.number].push({ date: d.date_of_subscription, plan: d.plan || "—" });
    return acc;
}, {});

// ── Active subscription check ─────────────────────────────────────────────────
const planDurationMonths = (plan) => {
    if (!plan) return 1;
    const p = plan.toLowerCase();
    if (p.includes("max")) return 12;
    if (p.includes("plus")) return 3;
    return 1;
};

const isActive = (phone) => {
    const entries = allSubDatesMap[phone] || [];
    if (entries.length === 0) return false;
    const latest = [...entries].sort((a, b) => new Date(b.date) - new Date(a.date))[0];
    const subDate = new Date(latest.date);
    if (isNaN(subDate)) return false;
    const expiry = new Date(subDate);
    expiry.setMonth(expiry.getMonth() + planDurationMonths(latest.plan));
    return expiry >= new Date();
};

const getExpiryDate = (phone) => {
    const entries = allSubDatesMap[phone] || [];
    if (entries.length === 0) return null;
    const latest = [...entries].sort((a, b) => new Date(b.date) - new Date(a.date))[0];
    const subDate = new Date(latest.date);
    if (isNaN(subDate)) return null;
    const expiry = new Date(subDate);
    expiry.setMonth(expiry.getMonth() + planDurationMonths(latest.plan));
    return expiry;
};

const getCurrentPlan = (phone) => {
    if (!isActive(phone)) return null;
    const entries = allSubDatesMap[phone] || [];
    if (entries.length === 0) return null;
    return [...entries].sort((a, b) => new Date(b.date) - new Date(a.date))[0].plan || null;
};

// ── Firestore batched "in" query (max 10 per chunk) ──────────────────────────
const batchedIn = async (collName, field, values) => {
    const chunks = [];
    for (let i = 0; i < values.length; i += 10) chunks.push(values.slice(i, i + 10));
    const snaps = await Promise.all(
        chunks.map((chunk) => getDocs(query(collection(db, collName), where(field, "in", chunk))))
    );
    return snaps.flatMap((snap) => snap.docs);
};

// ── Date helpers ─────────────────────────────────────────────────────────────
const toDate = (val) => {
    if (!val) return null;
    if (val?.toDate) return val.toDate();
    if (val instanceof Date) return val;
    const d = new Date(val);
    return isNaN(d) ? null : d;
};

const toTitleCase = (str) => {
    if (!str) return "—";
    return str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
};

const fmtDate = (val) => {
    const d = toDate(val);
    if (!d) return val ? String(val) : "—";
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

const inRange = (val, start, end) => {
    const d = toDate(val);
    return d && d >= start && d <= end;
};

// ── Component ─────────────────────────────────────────────────────────────────
function SubscriptionUserMetrix() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fromDate, setFromDate] = useState("2025-01-01");
    const [toDate, setToDate] = useState("2026-05-20");
    const [applied, setApplied] = useState({ from: "2025-01-01", to: "2026-05-20" });
    const [activeFilter, setActiveFilter] = useState("all");
    const [planFilter, setPlanFilter] = useState("all");
    const [renewedModal, setRenewedModal] = useState(null); // { phone, dates: [] }
    const [courseModal, setCourseModal] = useState(null); // { phone, items: [] }
    const [workshopModal, setWorkshopModal] = useState(null); // { phone, items: [] }
    const [certModal, setCertModal] = useState(null); // { phone, items: [] }

    useEffect(() => {
        const fetchAll = async () => {
            setLoading(true);

            const rangeStart = new Date(`${applied.from}T00:00:00`);
            const rangeEnd = new Date(`${applied.to}T23:59:59`);

            // Initialise row map with static data
            const rowMap = {};
            UNIQUE_NUMBERS.forEach((num) => {
                rowMap[num] = {
                    phone: num,
                    dateOfSubscription: firstSubMap[num],
                    renewedTimes: countMap[num] - 1,   // subtract first/original sub
                    fullName: null,
                    dateOfJoining: null,
                    ageRange: null,
                    profileType: null,
                    workshops: 0,
                    workshopDetails: [],
                    courses: 0,
                    courseDetails: [],
                    certs: 0,
                    certDetails: [],
                    portfolio: false,
                    rgApplied: false,
                    city: null,
                    state: null,
                };
            });

            try {
                // 1a. personal_details  →  joining date
                const pdDocs = await batchedIn("personal_details", "phone_no", UNIQUE_NUMBERS);
                pdDocs.forEach((doc) => {
                    const d = doc.data();
                    if (!rowMap[d.phone_no]) return;
                    if (!rowMap[d.phone_no].dateOfJoining) {
                        rowMap[d.phone_no].fullName = d.full_name || null;
                        rowMap[d.phone_no].dateOfJoining = d.created_date;
                    }
                });

                // 1b. profile_type  →  age range, profile type
                const ptDocs = await batchedIn("profile_type", "phone_no", UNIQUE_NUMBERS);
                ptDocs.forEach((doc) => {
                    const d = doc.data();
                    if (!rowMap[d.phone_no]) return;
                    if (!rowMap[d.phone_no].ageRange) {
                        rowMap[d.phone_no].ageRange = d.age_range;
                        rowMap[d.phone_no].profileType = d.profile_type;
                    }
                });

                // 2. workshop_registration  →  count + store details
                const wrDocs = await batchedIn("workshop_registration", "phone", UNIQUE_NUMBERS);
                wrDocs.forEach((doc) => {
                    const d = doc.data();
                    if (rowMap[d.phone] && inRange(d.created_date, rangeStart, rangeEnd)) {
                        rowMap[d.phone].workshops += 1;
                        rowMap[d.phone].workshopDetails.push({
                            phone: d.phone,
                            workshop_event_name: d.workshop_event_name || d.event_name || d.name || "—",
                            created_date: d.created_date,
                        });
                    }
                });

                // 3. nv_enrolled_courses  →  count + store details
                const ecDocs = await batchedIn("nv_enrolled_courses", "phone_no", UNIQUE_NUMBERS);
                ecDocs.forEach((doc) => {
                    const d = doc.data();
                    if (rowMap[d.phone_no] && inRange(d.created_date, rangeStart, rangeEnd)) {
                        rowMap[d.phone_no].courses += 1;
                        rowMap[d.phone_no].courseDetails.push({
                            phone_no: d.phone_no,
                            course_name: d.course_name || "—",
                            created_date: d.created_date,
                        });
                    }
                });

                // 4. downloaded_cretificate_data  →  count + store details
                const certDocs = await batchedIn("downloaded_cretificate_data", "phone", UNIQUE_NUMBERS);
                certDocs.forEach((doc) => {
                    const d = doc.data();
                    if (rowMap[d.phone] && inRange(d.created_date, rangeStart, rangeEnd)) {
                        rowMap[d.phone].certs += 1;
                        rowMap[d.phone].certDetails.push({
                            phone: d.phone,
                            created_date: d.created_date,
                            workshop_name: d.workshop_name || "—",
                        });
                    }
                });

                // 5. nv_portfolio_details  →  portfolio yes/no
                const pfDocs = await batchedIn("nv_portfolio_details", "phone_no", UNIQUE_NUMBERS);
                pfDocs.forEach((doc) => {
                    const d = doc.data();
                    if (rowMap[d.phone_no]) rowMap[d.phone_no].portfolio = true;
                });

                // 6. nv_loan  →  RG applied yes/no (username = phone)
                const loanDocs = await batchedIn("nv_loan", "username", UNIQUE_NUMBERS);
                loanDocs.forEach((doc) => {
                    const d = doc.data();
                    if (rowMap[d.username]) rowMap[d.username].rgApplied = true;
                });

                // 6. parlour_name  →  city, state
                const pnDocs = await batchedIn("parlour_name", "phone", UNIQUE_NUMBERS);
                pnDocs.forEach((doc) => {
                    const d = doc.data();
                    if (!rowMap[d.phone]) return;
                    if (!rowMap[d.phone].city) {
                        rowMap[d.phone].city = d.city;
                        rowMap[d.phone].state = d.state;
                    }
                });

                // Deduplicate by phone (guard against StrictMode double-fire)
                const seen = new Set();
                const uniqueRows = Object.values(rowMap).filter((r) => {
                    if (seen.has(r.phone)) return false;
                    seen.add(r.phone);
                    return true;
                });
                uniqueRows.sort((a, b) => new Date(b.dateOfSubscription) - new Date(a.dateOfSubscription));
                setRows(uniqueRows);
            } catch (err) {
                console.error("SubscriptionUserMetrix fetch error:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, [applied]);

    const handleExport = () => {
        const wb = XLSX.utils.book_new();

        // Sheet 1 — Summary
        const summaryData = rows.map((row, i) => ({
            "#": i + 1,
            Phone: row.phone,
            Name: toTitleCase(row.fullName),
            "Age Range": row.ageRange || "—",
            "Profile Type": row.profileType || "—",
            City: row.city || "—",
            State: row.state || "—",
            "Date of Joining": fmtDate(row.dateOfJoining),
            "Date of Subscription": fmtDate(row.dateOfSubscription),
            "Renewed Times": row.renewedTimes,
            Workshops: row.workshops,
            Courses: row.courses,
            Portfolio: row.portfolio ? "Yes" : "No",
            "RG Applied": row.rgApplied ? "Yes" : "No",
            "Active Subscription": isActive(row.phone) ? "Yes" : "No",
            "Current Plan": getCurrentPlan(row.phone) || "—",
            "Expires On": getExpiryDate(row.phone) ? fmtDate(getExpiryDate(row.phone)) : "—",
        }));
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(summaryData), "Summary");

        // Sheet 2 — Workshop Details
        const workshopData = [];
        rows.forEach((row) => {
            const ms = (v) => { if (!v) return 0; if (v?.toDate) return v.toDate().getTime(); const d = new Date(v); return isNaN(d) ? 0 : d.getTime(); };
            [...row.workshopDetails]
                .sort((a, b) => ms(b.created_date) - ms(a.created_date))
                .forEach((item) => {
                    workshopData.push({
                        Phone: item.phone,
                        Name: toTitleCase(row.fullName),
                        "Workshop / Event": item.workshop_event_name,
                        Date: fmtDate(item.created_date),
                    });
                });
        });
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(workshopData.length ? workshopData : [{}]), "Workshop Details");

        // Sheet 3 — Course Details
        const courseData = [];
        rows.forEach((row) => {
            const ms = (v) => { if (!v) return 0; if (v?.toDate) return v.toDate().getTime(); const d = new Date(v); return isNaN(d) ? 0 : d.getTime(); };
            [...row.courseDetails]
                .sort((a, b) => ms(b.created_date) - ms(a.created_date))
                .forEach((item) => {
                    courseData.push({
                        Phone: item.phone_no,
                        Name: toTitleCase(row.fullName),
                        "Course Name": item.course_name,
                        Date: fmtDate(item.created_date),
                    });
                });
        });
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(courseData.length ? courseData : [{}]), "Course Details");

        // Sheet 4 — Subscription / Renewal Dates
        const renewalData = [];
        rows.forEach((row) => {
            [...(allSubDatesMap[row.phone] || [])]
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .forEach((entry) => {
                    renewalData.push({
                        Phone: row.phone,
                        Name: toTitleCase(row.fullName),
                        Plan: entry.plan,
                        "Subscription Date": fmtDate(entry.date),
                    });
                });
        });
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(renewalData.length ? renewalData : [{}]), "Subscription Dates");

        XLSX.writeFile(wb, `subscription_metrics_${applied.from}_to_${applied.to}.xlsx`);
    };

    return (
        <>
            {/* HEADER */}
            <div className="bg-dark text-white py-3 px-4 d-flex justify-content-between align-items-center shadow-sm">
                <h5 className="mb-0 fw-bold">Subscription User Metrics</h5>
                <Link to="/">
                    <img
                        src="/images/menubutton.png"
                        alt="Menu"
                        style={{ height: "2rem", filter: "invert(1)" }}
                    />
                </Link>
            </div>

            <div className="container-fluid py-4">

                {/* CONTROLS */}
                <div className="d-flex align-items-center gap-3 mb-4 flex-wrap">
                    <span className="badge bg-dark fs-6">{UNIQUE_NUMBERS.length} subscribers</span>

                    <div className="d-flex align-items-center gap-2 flex-wrap">
                        {/* <label className="form-label mb-0 small fw-semibold">From:</label> */}
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            style={{ width: "150px" }}
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                        {/* <label className="form-label mb-0 small fw-semibold">To:</label> */}
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            style={{ width: "150px" }}
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                        <button
                            className="btn btn-dark btn-sm px-3"
                            onClick={() => setApplied({ from: fromDate, to: toDate })}
                            disabled={loading}
                            style={{ top: "6px" }}
                        >
                            Apply
                        </button>
                        <button
                            className="btn btn-success btn-sm px-3"
                            onClick={handleExport}
                            disabled={loading || rows.length === 0}
                            style={{ top: "6px" }}
                        >
                            ↓ Export Excel
                        </button>
                    </div>
                    <select
                        className="form-select form-select-sm"
                        style={{ width: "170px" }}
                        value={activeFilter}
                        onChange={(e) => setActiveFilter(e.target.value)}
                    >
                        <option value="all">Active: All</option>
                        <option value="yes">Active: Yes</option>
                        <option value="no">Active: No</option>
                    </select>
                    <select
                        className="form-select form-select-sm"
                        style={{ width: "180px" }}
                        value={planFilter}
                        onChange={(e) => setPlanFilter(e.target.value)}
                    >
                        <option value="all">Plan: All</option>
                        <option value="Glow">Glow</option>
                        <option value="Glow Plus">Glow Plus</option>
                        <option value="Glow Max">Glow Max</option>
                    </select>
                </div>

                {/* TABLE */}
                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-dark" />
                        <div className="mt-2 text-muted small">Fetching data…</div>
                    </div>
                ) : (
                    <div className="table-responsive">
                        <table
                            className="table table-bordered table-hover table-sm align-middle"
                            style={{ fontSize: "13px", whiteSpace: "nowrap" }}
                        >
                            <thead className="table-dark text-center">
                                <tr>
                                    <th>#</th>
                                    <th>Phone</th>
                                    <th>Name</th>
                                    <th>Age Range</th>
                                    <th>Profile Type</th>
                                    <th>City</th>
                                    <th>State</th>
                                    <th>Date of Joining</th>
                                    <th>Date of Subscription</th>
                                    <th>Renewed</th>
                                    <th>Active Subscription</th>
                                    <th>Current Plan</th>
                                    <th>Expires On</th>

                                    <th>
                                        Workshops
                                        <div className="fw-normal opacity-75" style={{ fontSize: "11px" }}>
                                            {applied.from} → {applied.to}
                                        </div>
                                    </th>
                                    <th>
                                        Courses
                                        <div className="fw-normal opacity-75" style={{ fontSize: "11px" }}>
                                            {applied.from} → {applied.to}
                                        </div>
                                    </th>
                                    {/* <th>
                                        Certifications
                                        <div className="fw-normal opacity-75" style={{ fontSize: "11px" }}>
                                            {applied.from} → {applied.to}
                                        </div>
                                    </th> */}
                                    <th>Portfolio</th>
                                    <th>RG Applied</th>


                                </tr>
                            </thead>
                            <tbody>
                                {rows.filter((row) => {
                                    if (activeFilter === "yes" && !isActive(row.phone)) return false;
                                    if (activeFilter === "no" && isActive(row.phone)) return false;
                                    if (planFilter !== "all" && getCurrentPlan(row.phone) !== planFilter) return false;
                                    return true;
                                }).map((row, i) => (
                                    <tr key={row.phone}>
                                        <td className="text-center text-muted">{i + 1}</td>
                                        <td className="fw-semibold">{row.phone}</td>
                                        <td>{toTitleCase(row.fullName)}</td>
                                        <td>{row.ageRange || "—"}</td>
                                        <td>{row.profileType || "—"}</td>
                                        <td>{row.city || "—"}</td>
                                        <td>{row.state || "—"}</td>
                                        <td>{fmtDate(row.dateOfJoining)}</td>
                                        <td>{fmtDate(row.dateOfSubscription)}</td>
                                        <td className="text-center">
                                            {row.renewedTimes > 0
                                                ? (
                                                    <span
                                                        className="badge bg-success"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            const entries = [...(allSubDatesMap[row.phone] || [])].sort((a, b) => new Date(b.date) - new Date(a.date));
                                                            setRenewedModal({ phone: row.phone, dates: entries });
                                                        }}
                                                    >
                                                        {row.renewedTimes}×
                                                    </span>
                                                )
                                                : <span className="text-muted">—</span>}
                                        </td>
                                        <td className="text-center">
                                            {isActive(row.phone)
                                                ? <span className="badge bg-success">Yes</span>
                                                : <span className="badge bg-danger">No</span>}
                                        </td>
                                        <td className="text-center">
                                            {getCurrentPlan(row.phone)
                                                ? <span className="badge bg-primary">{getCurrentPlan(row.phone)}</span>
                                                : <span className="text-muted">—</span>}
                                        </td>
                                        <td className="text-center">
                                            {getExpiryDate(row.phone)
                                                ? <span className={getExpiryDate(row.phone) >= new Date() ? "text-success fw-semibold" : "text-danger"}>
                                                    {fmtDate(getExpiryDate(row.phone))}
                                                </span>
                                                : <span className="text-muted">—</span>}
                                        </td>
                                        <td className="text-center">
                                            {row.workshops > 0
                                                ? (
                                                    <span
                                                        className="badge bg-primary"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            const ms = (v) => {
                                                                if (!v) return 0;
                                                                if (v?.toDate) return v.toDate().getTime();
                                                                const d = new Date(v);
                                                                return isNaN(d) ? 0 : d.getTime();
                                                            };
                                                            const sorted = [...row.workshopDetails].sort((a, b) => ms(b.created_date) - ms(a.created_date));
                                                            setWorkshopModal({ phone: row.phone, items: sorted });
                                                        }}
                                                    >
                                                        {row.workshops}
                                                    </span>
                                                )
                                                : <span className="text-muted">—</span>}
                                        </td>
                                        <td className="text-center">
                                            {row.courses > 0
                                                ? (
                                                    <span
                                                        className="badge bg-info text-dark"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            const ms = (v) => {
                                                                if (!v) return 0;
                                                                if (v?.toDate) return v.toDate().getTime();
                                                                const d = new Date(v);
                                                                return isNaN(d) ? 0 : d.getTime();
                                                            };
                                                            const sorted = [...row.courseDetails].sort((a, b) => ms(b.created_date) - ms(a.created_date));
                                                            setCourseModal({ phone: row.phone, items: sorted });
                                                        }}
                                                    >
                                                        {row.courses}
                                                    </span>
                                                )
                                                : <span className="text-muted">—</span>}
                                        </td>
                                        {/* <td className="text-center">
                                            {row.certs > 0
                                                ? (
                                                    <span
                                                        className="badge bg-warning text-dark"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => setCertModal({ phone: row.phone, items: row.certDetails })}
                                                    >
                                                        {row.certs}
                                                    </span>
                                                )
                                                : <span className="text-muted">—</span>}
                                        </td> */}
                                        <td className="text-center">
                                            {row.portfolio
                                                ? <span className="badge bg-success">Yes</span>
                                                : <span className="badge bg-secondary">No</span>}
                                        </td>
                                        <td className="text-center">
                                            {row.rgApplied
                                                ? <span className="badge bg-success">Yes</span>
                                                : <span className="badge bg-secondary">No</span>}
                                        </td>


                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* WORKSHOP DETAIL MODAL */}
            {workshopModal && (
                <div
                    onClick={() => setWorkshopModal(null)}
                    style={{
                        position: "fixed", inset: 0,
                        background: "rgba(0,0,0,0.6)",
                        zIndex: 9999,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        padding: "20px",
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: "#fff",
                            borderRadius: "14px",
                            width: "100%",
                            maxWidth: "560px",
                            maxHeight: "80vh",
                            display: "flex",
                            flexDirection: "column",
                            boxShadow: "0 8px 40px rgba(0,0,0,0.25)",
                        }}
                    >
                        {/* Modal header */}
                        <div className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
                            <div>
                                <div className="fw-bold" style={{ fontSize: "15px" }}>Workshop Registrations</div>
                                <div className="text-muted" style={{ fontSize: "12px" }}>{workshopModal.phone}</div>
                            </div>
                            <button
                                className="btn-close"
                                onClick={() => setWorkshopModal(null)}
                            />
                        </div>

                        {/* Modal body */}
                        <div style={{ overflowY: "auto", padding: "16px" }}>
                            {workshopModal.items.length === 0 ? (
                                <p className="text-muted text-center">No details available.</p>
                            ) : (
                                <table className="table table-sm table-bordered align-middle mb-0" style={{ fontSize: "13px" }}>
                                    <thead className="table-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>Phone</th>
                                            <th>Workshop / Event</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {workshopModal.items.map((item, i) => (
                                            <tr key={i}>
                                                <td className="text-muted">{i + 1}</td>
                                                <td>{item.phone}</td>
                                                <td>{item.workshop_event_name}</td>
                                                <td>{fmtDate(item.created_date)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {/* COURSE DETAIL MODAL */}
            {courseModal && (
                <div
                    onClick={() => setCourseModal(null)}
                    style={{
                        position: "fixed", inset: 0,
                        background: "rgba(0,0,0,0.6)",
                        zIndex: 9999,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        padding: "20px",
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: "#fff",
                            borderRadius: "14px",
                            width: "100%",
                            maxWidth: "520px",
                            maxHeight: "80vh",
                            display: "flex",
                            flexDirection: "column",
                            boxShadow: "0 8px 40px rgba(0,0,0,0.25)",
                        }}
                    >
                        <div className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
                            <div>
                                <div className="fw-bold" style={{ fontSize: "15px" }}>Enrolled Courses</div>
                                <div className="text-muted" style={{ fontSize: "12px" }}>{courseModal.phone}</div>
                            </div>
                            <button className="btn-close" onClick={() => setCourseModal(null)} />
                        </div>
                        <div style={{ overflowY: "auto", padding: "16px" }}>
                            {courseModal.items.length === 0 ? (
                                <p className="text-muted text-center">No details available.</p>
                            ) : (
                                <table className="table table-sm table-bordered align-middle mb-0" style={{ fontSize: "13px" }}>
                                    <thead className="table-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>Phone</th>
                                            <th>Course Name</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {courseModal.items.map((item, i) => (
                                            <tr key={i}>
                                                <td className="text-muted">{i + 1}</td>
                                                <td>{item.phone_no}</td>
                                                <td>{item.course_name}</td>
                                                <td>{fmtDate(item.created_date)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* RENEWED DATES MODAL */}
            {renewedModal && (
                <div
                    onClick={() => setRenewedModal(null)}
                    style={{
                        position: "fixed", inset: 0,
                        background: "rgba(0,0,0,0.6)",
                        zIndex: 9999,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        padding: "20px",
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: "#fff",
                            borderRadius: "14px",
                            width: "100%",
                            maxWidth: "360px",
                            maxHeight: "80vh",
                            display: "flex",
                            flexDirection: "column",
                            boxShadow: "0 8px 40px rgba(0,0,0,0.25)",
                        }}
                    >
                        <div className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
                            <div>
                                <div className="fw-bold" style={{ fontSize: "15px" }}>Subscription Dates</div>
                                <div className="text-muted" style={{ fontSize: "12px" }}>{renewedModal.phone}</div>
                            </div>
                            <button className="btn-close" onClick={() => setRenewedModal(null)} />
                        </div>
                        <div style={{ overflowY: "auto", padding: "16px" }}>
                            <table className="table table-sm table-bordered align-middle mb-0" style={{ fontSize: "13px" }}>
                                <thead className="table-dark">
                                    <tr>
                                        <th>#</th>
                                        <th>Plan</th>
                                        <th>Subscription Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renewedModal.dates.map((entry, i) => (
                                        <tr key={i}>
                                            <td className="text-muted">{i + 1}</td>
                                            <td><span className="badge bg-dark">{entry.plan}</span></td>
                                            <td>{fmtDate(entry.date)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            {/* CERTIFICATION DETAIL MODAL */}
            {certModal && (
                <div
                    onClick={() => setCertModal(null)}
                    style={{
                        position: "fixed", inset: 0,
                        background: "rgba(0,0,0,0.6)",
                        zIndex: 9999,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        padding: "20px",
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: "#fff",
                            borderRadius: "14px",
                            width: "100%",
                            maxWidth: "460px",
                            maxHeight: "80vh",
                            display: "flex",
                            flexDirection: "column",
                            boxShadow: "0 8px 40px rgba(0,0,0,0.25)",
                        }}
                    >
                        {/* Modal header */}
                        <div className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
                            <div>
                                <div className="fw-bold" style={{ fontSize: "15px" }}>Certifications</div>
                                <div className="text-muted" style={{ fontSize: "12px" }}>{certModal.phone}</div>
                            </div>
                            <button
                                className="btn-close"
                                onClick={() => setCertModal(null)}
                            />
                        </div>

                        {/* Modal body */}
                        <div style={{ overflowY: "auto", padding: "16px" }}>
                            {certModal.items.length === 0 ? (
                                <p className="text-muted text-center">No details available.</p>
                            ) : (
                                <table className="table table-sm table-bordered align-middle mb-0" style={{ fontSize: "13px" }}>
                                    <thead className="table-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>Phone</th>
                                            <th>Workshop Name</th>
                                            <th>Created Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {certModal.items.map((item, i) => (
                                            <tr key={i}>
                                                <td className="text-muted">{i + 1}</td>
                                                <td>{item.phone}</td>
                                                <td>{item.workshop_name}</td>
                                                <td>{fmtDate(item.created_date)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default SubscriptionUserMetrix;
